import { isFuture } from 'date-fns';
import type { Campaign, CampaignDisplayStatus } from '../api/models/bff/Campaign';

const RUNNING_CAMPAIGN_STATUSES: CampaignDisplayStatus[] = ['ACTIVE', 'AVAILABLE', 'LIMITED'];

export type RunnableCampaign = Pick<Campaign, 'code' | 'displayStatus' | 'boundaryType' | 'endDate'>;

export function isCampaignRunning(campaign: Pick<RunnableCampaign, 'displayStatus'>): boolean {
  return RUNNING_CAMPAIGN_STATUSES.includes(campaign.displayStatus);
}

export function isCampaignClosed(campaign: Pick<RunnableCampaign, 'displayStatus'> | undefined): boolean {
  return campaign?.displayStatus === 'CLOSED';
}

export function campaignRunsUntil(campaign: Pick<RunnableCampaign, 'displayStatus' | 'endDate'> | undefined): Date | undefined {
  if (campaign?.displayStatus !== 'ACTIVE' || !campaign.endDate) return undefined;
  const end = new Date(campaign.endDate);

  return isFuture(end) ? end : undefined;
}